import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPendingRedeemVerifications as getPendingRedeemVerificationsApi } from "services/apis/admin";

export const fetchPendingRedeemVerifications = createAsyncThunk(
  "redeemVerification/fetchPending",
  async ({ token, currentPage, userType }: any, thunkAPI) => {
    try {
      const response = await getPendingRedeemVerificationsApi(token, currentPage, userType);
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

interface PendingRedeemVerificationsState {
  pendingRedeemVerifications: any;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: PendingRedeemVerificationsState = {
  pendingRedeemVerifications: [],
  status: "idle",
  error: null,
};

const getPendingRedeemVerificationsSlice = createSlice({
  name: "getPendingRedeemVerifications",
  initialState,
  reducers: {
    resetPendingRedeemVerificationsStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingRedeemVerifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPendingRedeemVerifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.pendingRedeemVerifications = action.payload;
      })
      .addCase(fetchPendingRedeemVerifications.rejected, (state, action: any) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetPendingRedeemVerificationsStatus } = getPendingRedeemVerificationsSlice.actions;
export default getPendingRedeemVerificationsSlice.reducer;
